import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  MaintenancePlanGroupForm,
  MaintenancePlanGroupFormValues,
} from "../../components/maintenance-plan-group-form";
import { Modal } from "../../components/modal";
import { createMaintenancePlanGroup } from "../../services/maintenance-plan-group";
import { navigateBack } from "../../utils/navigate-back";

export function MaintenancePlanGroupCreate() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [formValues, setFormValues] = useState<MaintenancePlanGroupFormValues>({
    name: "",
  });

  const closeModal = () => {
    navigateBack(navigate, "/admin/maintenance/groups");
  };

  return (
    <Modal open onClose={closeModal}>
      <MaintenancePlanGroupForm
        hasError={hasError}
        loading={loading}
        values={formValues}
        onCancel={closeModal}
        onChange={setFormValues}
        onSubmit={() => {
          void (async () => {
            setLoading(true);
            setHasError(false);
            try {
              await createMaintenancePlanGroup({ name: formValues.name });
              await queryClient.invalidateQueries({
                queryKey: ["maintenancePlanGroups"],
              });
              closeModal();
            } catch {
              setHasError(true);
            } finally {
              setLoading(false);
            }
          })();
        }}
      />
    </Modal>
  );
}
